// extracted by mini-css-extract-plugin
export default {"tituloContainer":"TituloComponent_tituloContainer__kZ6pT","titulo":"TituloComponent_titulo__CxCPJ","underline":"TituloComponent_underline__38bsb"};